import { LicenseStatuses } from '@enums'
import { ISubmissionsPendingData } from '@store/postCampaignReport'

export const DEFAULT_TENANT = 'tribe'

export const APP_LOCALE = 'en-AU'

export const HIDDEN_CREDIT_CARD_PREFIX =
  '\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022'

export const DEFAULT_SUBMISSIONS_PENDING_DATA: ISubmissionsPendingData = {
  posts: 0,
  videos: 0,
  stories: 0,
  tiktok: 0,
}
export const EMPTY_LIST: ReadonlyArray<any> = []

// Stable empty-object reference. Use as a fallback (e.g. `value || EMPTY_OBJECT`)
// instead of an inline `{}`: a fresh `{}` each render defeats react-redux's
// shallowEqual and triggers infinite re-render loops under react-redux 9.
// Typed loosely (like EMPTY_LIST) so it can stand in for any entity fallback,
// e.g. `state.byId[id] || (EMPTY_OBJECT as ICampaign)`.
export const EMPTY_OBJECT: Readonly<Record<string, any>> = {}

export const NOT_FOUND_STATUS = 404

export const DECINE_REASON_CHARACTER_LIMIT = 800

export const DEFAULT_PAID_PARTNERSHIP_HANDLE = '@tribe'

export const METRIC_DISPUTE_FEEDBACK_CHARACTER_LIMIT = 300

export const RELICENSE_STATUSES = [
  LicenseStatuses.RequestExpired,
  LicenseStatuses.DeclinedByBrand,
  LicenseStatuses.Cancelled,
]
